import { ContentRoutes } from 'enums/routes';
import {
  RoutesPage,
  TablePage,
  NewRoute,
  User,
  Roles,
  Auth,
  Show,
  Company,
  UserShow,
  Dashboard,
  Unauthorized,
  NotFound,
  Checklists,
} from 'pages';

export const routes = [
  {
    exact: true,
    path: '/login',
    Component: Auth,
    routeName: 'Login',
  }, {
    exact: true,
    path: '/signup',
    Component: Auth,
    routeName: 'FirstLogin',
  },
  {
    exact: true,
    path: '/password',
    Component: Auth,
    routeName: 'NewPassword',
  },
  {
    exact: true,
    path: '/passwordrecovery',
    Component: Auth,
    routeName: 'Recovery',
  },
  {
    exact: true,
    path: '/403',
    Component: Unauthorized,
  },
  {
    exact: true,
    path: '/table/:content/:id?',
    isSafeRoute: true,
    Component: TablePage,
  },
  {
    exact: true,
    path: '/profile',
    isSafeRoute: true,
    Component: User,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Routes}`,
    isSafeRoute: true,
    Component: NewRoute,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Roles}`,
    isSafeRoute: true,
    Component: Roles,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Roles}/:id`,
    isSafeRoute: true,
    Component: Roles,
  },
  {
    exact: true,
    path: '/company/:id?',
    isSafeRoute: true,
    Component: Company,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Users}/:id`,
    isSafeRoute: true,
    Component: User,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Drivers}/:id`,
    isSafeRoute: true,
    Component: User,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Routes}/:id`,
    isSafeRoute: true,
    Component: RoutesPage,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Checklists}`,
    isSafeRoute: true,
    Component: Checklists,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Checklists}/:id/:executionId`,
    isSafeRoute: true,
    Component: Checklists,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Checklists}/:id`,
    isSafeRoute: true,
    Component: Checklists,
  },
  {
    exact: true,
    path: '/:content/:id',
    isSafeRoute: true,
    Component: Show,
  },
  {
    exact: true,
    path: `/${ContentRoutes.Users}/:content/:id`,
    isSafeRoute: true,
    Component: UserShow,
  },
  {
    exact: true,
    path: '/',
    isSafeRoute: true,
    Component: Dashboard,
  },
  {
    exact: true,
    path: '/dashboard',
    isSafeRoute: true,
    Component: Dashboard,
  },
  {
    Component: NotFound,
  },
];
